import { useEffect, useState, useCallback, useMemo, memo, useRef } from 'react';
import { Link } from 'react-router-dom';
import Api from '../Auth/Api';
import { Controller, useForm } from 'react-hook-form';
import { Modal, Toast, Offcanvas, Badge } from 'react-bootstrap';
import Select from 'react-select';
import { decodeJWT, formatDate } from '../Components/jwtUtils';
import TextareaAutosize from "react-textarea-autosize";
import Tippy from '@tippyjs/react';
import { customStyles } from '../utils/selectStyles';
import { CourseSkeletons } from '../Components/Skeletons/CourseSkeleton';
import CursosManager from '../Components/Dashboard/Cursos/CursosManager';
import TopicosManager from '../Components/Dashboard/Topicos/TopicosManager';
import 'tippy.js/dist/tippy.css';

// GridViewItem com memo para evitar renderizações desnecessárias
const GridViewItem = memo(({ value, nivel, certificadosStatus, imageOverlayStyle, overlayContentStyle, handleImageError, formatDate, dataGestor, dataTopicos, setShowModalEditarCurso, setValue_curso, setCursoEditarFile, setThumbEdit, setUploadCursoProgress, setPreviewUrl, setShowModalDeletarCurso, setCursoInfo, setShowModalCertificado, setCertificadoEdit, setCertificadoFrenteEdit, setCursoEditarCertificado, setCursoEditarCertificadoFrente, setPreviewUrlCertificado, setPreviewUrlCertificadoFrente, setCertificadoImageError, setCertificadoFrenteImageError }) => {
    const hoje = new Date();
    const dataInicio = new Date(value.dataInicio);
    const dataFinal = new Date(value.dataFinal);

    // Reciclagem automática: o curso é reiniciado sozinho perto do vencimento e o certificado anterior vale até vencer
    const certificadoStatus = certificadosStatus[value.id];
    const certificadoExpirado = certificadoStatus?.certificado_expirado;
    const reciclagemLiberada = certificadoStatus?.reciclagem_liberada;

    const cursoCardStyle = {
        display: value.disponivel === 1 ? 'block' : 'none',
        width: '100%',
        height: '100%'
    };

    const cursoCardInnerStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: '#212529',
        borderRadius: '0.375rem',
        overflow: 'hidden',
        boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)'
    };

    if (nivel !== 'Aluno' || (hoje >= dataInicio && hoje <= dataFinal)) {
        return (
            <div style={cursoCardStyle}>
                <div style={cursoCardInnerStyle}>
                    <div style={{ position: 'relative', width: '100%', height: '200px', overflow: 'hidden' }}>
                        <img 
                            src={`${process.env.REACT_APP_IMG_URL}/${value.thumbnail}`}
                            style={{ 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'cover',
                                display: 'block'
                            }}
                                alt="Course cover"
                            onError={handleImageError} 
                        />
                            <div style={imageOverlayStyle}></div>
                        <div style={{ 
                            position: 'absolute', 
                            top: 0, 
                            left: 0, 
                            right: 0, 
                            bottom: 0, 
                            display: 'flex', 
                            flexDirection: 'column', 
                            justifyContent: 'space-between',
                            padding: '1rem',
                            zIndex: 1
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <h5 style={{
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                    color: 'white',
                                    marginBottom: '0.5rem',
                                    padding: '0.5rem',
                                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                        borderRadius: '5px',
                                        width: 'fit-content'
                                    }}>{value.nome}</h5>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.375rem', marginBottom: '0.5rem' }}>
                                    <span className='badge bg-primary text-dark' style={{
                                        width: 'fit-content',
                                        fontSize: '0.75rem',
                                        fontWeight: 300
                                    }}>{value.nomeTopico}</span>
                                    {certificadoExpirado ? (
                                        <span className="badge bg-danger" style={{ fontSize: '0.75rem' }}>Certificado Expirado</span>
                                    ) : reciclagemLiberada && (
                                        <Tippy content={certificadoStatus.message}>
                                            <span className="badge bg-warning text-dark" style={{ fontSize: '0.75rem' }}>
                                                <i className="bi bi-arrow-repeat me-1"></i>Reciclagem liberada
                                            </span>
                                        </Tippy>
                                    )}
                                </div>
                                </div>

                                <div>
                                <div style={{ 
                                    display: 'flex', 
                                    flexWrap: 'wrap', 
                                    gap: '0.5rem', 
                                    marginBottom: '0.5rem' 
                                }}>
                                    <span style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        color: 'white' 
                                    }}>
                                            <i className="bi bi-book me-1"></i>
                                        <small style={{ color: 'white' }}>
                                            {value.qtd_aulas} {value.qtd_aulas === 1 ? "Aula" : "Aulas"}
                                        </small>
                                        </span>
                                    <span style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        color: 'white' 
                                    }}>
                                            <i className="bi bi-bookmark-check-fill me-1"></i>
                                        <small style={{ color: 'white' }}>
                                            {value.qtd_modulos} {value.qtd_modulos === 1 ? "Módulo" : "Módulos"}
                                        </small>
                                        </span>
                                    </div>

                                <div style={{ 
                                    display: 'flex', 
                                    flexWrap: 'wrap', 
                                    justifyContent: 'space-between', 
                                    alignItems: 'center', 
                                    gap: '0.5rem' 
                                }}>
                                    <span style={{ 
                                        fontSize: '0.875rem', 
                                        fontWeight: 400, 
                                        color: 'white' 
                                    }}>
                                        Carga Horária: <span style={{ fontWeight: 700 }}>
                                            {value.carga_horaria_total > 1 ? `${value.carga_horaria_total} horas` : `${value.carga_horaria_total} hora`}
                                        </span>
                                    </span>
                                    {value.tipo ? (
                                        <span className='badge bg-light text-dark'>
                                            {value.tipo === 'online' ? 'ONLINE' : 'HÍBRIDO'}
                                        </span>
                                    ) : (
                                        <span className='badge bg-danger text-white'>
                                            N/A
                                        </span>
                                    )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    <div style={{ 
                        backgroundColor: '#212529', 
                        padding: '0.5rem', 
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between'
                    }}>
                        {nivel === 'Aluno' && (() => {
                            const parsedPorcentagem = parseInt(value.porcentagem_concluida);
                            const hasPorcentagem = !isNaN(parsedPorcentagem) && parsedPorcentagem > 0 && parsedPorcentagem <= 100;
                            
                            if (!hasPorcentagem) return null;
                            
                            return (
                            <div style={{ 
                                width: '100%', 
                                height: '1.5rem', 
                                backgroundColor: '#495057', 
                                borderRadius: '0.25rem', 
                                overflow: 'hidden',
                                marginBottom: '0.5rem'
                            }}>
                                <div style={{ 
                                    height: '100%', 
                                        width: `${parsedPorcentagem}%`,
                                        backgroundColor: parsedPorcentagem === 100 ? '#198754' : '#f8f9fa',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                        color: parsedPorcentagem === 100 ? 'white' : '#212529',
                                    fontSize: '0.75rem',
                                    fontWeight: 500,
                                    transition: 'width 0.3s ease'
                                }}>
                                        {parsedPorcentagem}%
                                </div>
                            </div>
                            );
                        })()}

                        <div style={{ 
                            fontSize: '0.875rem', 
                            fontWeight: 300, 
                            marginBottom: '0.5rem', 
                            color: 'rgba(255, 255, 255, 0.5)' 
                        }}>
                            Disponível até {formatDate(value.dataFinal)}
                        </div>

                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            gap: '0.5rem' 
                        }}>
                                <Link to={`/modulos/${value.id}`} className="btn btn-outline-light link rounded py-1 flex-grow-1">
                                    Acessar
                                </Link>
                                {nivel === 'Administrador' && (
                                    <div className="d-flex gap-2">
                                        <Tippy content="Editar Curso">
                                            <span onClick={() => {
                                                setShowModalEditarCurso(true)
                                                setValue_curso('id', value.id)
                                                setValue_curso('nome', value.nome)
                                                setValue_curso('nome_certificado', value.nome_certificado)
                                                setValue_curso('descricao_certificado', value.descricao_certificado)
                                                setValue_curso('descricao', value.descricao)
                                                setValue_curso('resumo', value.resumo)
                                                setValue_curso('objetivo', value.objetivo || '')
                                                setValue_curso('conteudo_programatico', value.conteudo_programatico || '')
                                                setValue_curso('thumbnail', value.thumbnail)
                                                setValue_curso('tipo', value.tipo)
                                                setValue_curso('dataInicio', value.dataInicio)
                                                setValue_curso('dataFinal', value.dataFinal)
                                                const selectedTopico = dataTopicos.find(topicos => topicos.id === value.idTopico);
                                                setValue_curso('idTopico', { value: selectedTopico.id, label: selectedTopico.nome })
                                                setValue_curso('prazo_validade', value.prazo_validade)
                                                setCursoEditarFile(null)
                                                setThumbEdit(value.thumbnail)
                                                setUploadCursoProgress(0)
                                                setPreviewUrl(null)
                                            }} className="btn btn-outline-light py-1 px-2 rounded">
                                                <i className="bi bi-pencil"></i>
                                            </span>
                                        </Tippy>
                                        <Tippy content="Excluir Curso">
                                            <span onClick={() => { setShowModalDeletarCurso(true); setCursoInfo({ id: value.id, nome: value.nome }) }} className="btn btn-outline-light py-1 px-2 rounded">
                                                <i className="bi bi-trash"></i>
                                            </span>
                                        </Tippy>
                                        <Tippy content={value.certificado !== null ? 'Editar Certificado' : 'Adicionar Certificado'}>
                                        <span onClick={() => { setShowModalCertificado(true); setCertificadoEdit(value.certificado); setCertificadoFrenteEdit(value.certificado_frente); setCursoEditarCertificado(null); setCursoEditarCertificadoFrente(null); setPreviewUrlCertificado(null); setPreviewUrlCertificadoFrente(null); setCertificadoImageError(false); setCertificadoFrenteImageError(false); setCursoInfo({ id: value.id, nome: value.nome, certificado: value.certificado, certificado_frente: value.certificado_frente }) }} className={`d-flex align-items-center rounded link py-1 px-2 cursor-pointer ${value.certificado !== null ? 'bg-success text-white link-white' : 'bg-white text-dark'}`}>
                                                <i className="bi bi-patch-check"></i>
                                            </span>
                                        </Tippy>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return null;
});

function MeusCursos() {

    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivel = decodeJWT(token).nivel;
    const [showModalEditarCurso, setShowModalEditarCurso] = useState(false);
    const [showModalDeletarCurso, setShowModalDeletarCurso] = useState(false);
    const [isLoadingDeletarCurso, setIsLoadingDeletarCurso] = useState(false);
    const [showModalCertificado, setShowModalCertificado] = useState(false);
    const [showModalDeletarCertificado, setShowModalDeletarCertificado] = useState(false);
    const [certificadoParaDeletar, setCertificadoParaDeletar] = useState({ idCurso: null, tipo: null });
    const [cursoInfo, setCursoInfo] = useState({ id: null, nome: '' });
    const [cursoEditarFile, setCursoEditarFile] = useState(false);
    const [cursoEditarCertificado, setCursoEditarCertificado] = useState(false);
    const [uploadCursoProgress, setUploadCursoProgress] = useState(0);
    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [thumbEdit, setThumbEdit] = useState(false);
    const [certificadoEdit, setCertificadoEdit] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewUrlCertificado, setPreviewUrlCertificado] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [order, setOrder] = useState("");
    const [selectedTopic, setSelectedTopic] = useState(null);
    const [selectedTipo, setSelectedTipo] = useState(null);
    const [showButtonCertificado, setShowButtonCertificado] = useState(false);
    // Estados para frente do certificado
    const [cursoEditarCertificadoFrente, setCursoEditarCertificadoFrente] = useState(false);
    const [previewUrlCertificadoFrente, setPreviewUrlCertificadoFrente] = useState(null);
    const [certificadoFrenteEdit, setCertificadoFrenteEdit] = useState(null);
    const [showButtonCertificadoFrente, setShowButtonCertificadoFrente] = useState(false);
    const [certificadoImageError, setCertificadoImageError] = useState(false);
    const [certificadoFrenteImageError, setCertificadoFrenteImageError] = useState(false);
    const [showDrawerFiltros, setShowDrawerFiltros] = useState(false);
    /** Filtro equivalente aos cards de KPI (período / em andamento). Tipo usa `selectedTipo`. */
    const [filtroKpiCards, setFiltroKpiCards] = useState(null); // null | 'periodo' | 'em-andamento'
    const [isLoadingEditarCurso, setIsLoadingEditarCurso] = useState(false);
    const [showScrollTop, setShowScrollTop] = useState(false);
    const [showScrollBottom, setShowScrollBottom] = useState(false);
    const modalEditarCursoBodyRef = useRef(null);
    
    const [loading, setLoading] = useState(false);

    // Inicializar managers
    const cursosManager = CursosManager({ 
        token, 
        nivel,
        onCursoCreated: () => {
            recarregarCursos();
        }
    });
    const topicosManager = TopicosManager({ token });
    // URL para imagem placeholder quando não for possível carregar a imagem do curso
    const placeholderImage = "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM=";

    // Função para lidar com erro de carregamento de imagem
    const handleImageError = (e) => {
        e.target.src = placeholderImage;
    };

    // Função para tratar erro de imagem do certificado
    const handleCertificadoImageError = () => {
        setCertificadoImageError(true);
    };

    // Função para tratar erro de imagem da frente do certificado
    const handleCertificadoFrenteImageError = () => {
        setCertificadoFrenteImageError(true);
    };

    // Estado para armazenar os status de certificado para cada curso
    const [certificadosStatus, setCertificadosStatus] = useState({});

    // Estilo para o container da transição
    const containerTransitionStyle = {
        transition: 'all 0.3s ease-in-out',
        position: 'relative'
    };

    // Função para calcular gridTemplateColumns baseado no tamanho da tela
    const getGridColumns = () => {
        if (window.matchMedia('(min-width: 1400px)').matches) {
            // Tela muito grande (xxl): 4 colunas
            return 'repeat(4, 1fr)';
        } else if (window.matchMedia('(min-width: 992px)').matches) {
            // Tela grande (lg/xl): 3 colunas
            return 'repeat(3, 1fr)';
        } else if (window.matchMedia('(min-width: 768px)').matches) {
            // Tela média (md): 2 colunas
            return 'repeat(2, 1fr)';
        } else {
            // Tela pequena: 1 coluna
            return '1fr';
        }
    };

    const [gridColumns, setGridColumns] = useState(getGridColumns());

    // Atualizar grid quando a janela redimensionar
    useEffect(() => {
        const handleResize = () => {
            setGridColumns(getGridColumns());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Estilo para o gradiente escuro sobre as imagens
    const imageOverlayStyle = {
        background: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.8))',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        zIndex: 0,
        backdropFilter: 'blur(1px)',
        WebkitBackdropFilter: 'blur(1px)'
    };

    // Estilo para o conteúdo sobre o gradiente
    const overlayContentStyle = {
        position: 'absolute',
        zIndex: 0
    };

    const [dataTopicos, setDataTopicos] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-topicos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataTopicos(response.data);
            } catch (error) {
                console.error(error.response.data.message)
            }
        }
        fetchData();
    }, [token]);

    const handleThumbnailChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function (e) {
                setPreviewUrl(e.target.result);
            }
            reader.readAsDataURL(file);
        }
    }

    const handleCertificadoChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function (e) {
                setPreviewUrlCertificado(e.target.result);
            }
            reader.readAsDataURL(file);
        }
    }


    const handleCertificadoFrenteChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function (e) {
                setPreviewUrlCertificadoFrente(e.target.result);
            }
            reader.readAsDataURL(file);
        }
    }

    // Função para verificar o status do certificado de um curso - memoizada com useCallback
    const verificarStatusCertificado = useCallback(async (idCurso) => {
        try {
            const response = await Api.get(`api/verificar-status-certificado-curso/${idCurso}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao verificar status do certificado:", error);
            return null;
        }
    }, [token]);

    // Função para recarregar os cursos
    const recarregarCursos = useCallback(async () => {
        try {
            setLoading(true);
            const response = await Api.get(`api/listar-cursos`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            // Primeiro setamos os dados dos cursos para exibir na tela rapidamente
            setDataCursos(response.data);
            setLoading(false);

            // Depois verificamos os certificados se necessário
            if (nivel === 'Aluno' || nivel === 'Gestor') {
                // Verificamos todos os certificados em paralelo
                const statusPromises = response.data.map(curso => 
                    verificarStatusCertificado(curso.id)
                );
                
                // Aguardamos todas as requisições terminarem
                const statusesCompletos = await Promise.all(statusPromises);
                
                // Criamos o objeto com todos os status de uma vez só
                const statusesObj = {};
                response.data.forEach((curso, index) => {
                    if (statusesCompletos[index]) {
                        statusesObj[curso.id] = statusesCompletos[index];
                    }
                });
                
                setCertificadosStatus(statusesObj);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }, [token, nivel, verificarStatusCertificado]);

    // listar os cursos
    const [dataCursos, setDataCursos] = useState([]);
    useEffect(() => {
        recarregarCursos();
    }, [recarregarCursos]);

    let filteredCourses = dataCursos.filter(course => course.nome.toLowerCase().includes(searchTerm.toLowerCase()));

    switch (order) {
        case "1": // Ordem alfabética
            filteredCourses.sort((a, b) => a.nome.localeCompare(b.nome));
            break;
        case "2": // Recentes
            filteredCourses.sort((a, b) => new Date(a.dataInicio) - new Date(b.dataInicio));
            break;
        case "3": // Finalizados
            filteredCourses = filteredCourses.filter(course => parseInt(course.porcentagem_concluida) === 100);
            break;
        case "4": // Em andamento
            filteredCourses = filteredCourses.filter(course => parseInt(course.porcentagem_concluida) < 100);
            break;
        default:
            break;
    }

    if (filtroKpiCards === 'periodo') {
        const hoje = new Date();
        filteredCourses = filteredCourses.filter((course) => {
            const dataInicio = new Date(course.dataInicio);
            const dataFinal = new Date(course.dataFinal);
            return hoje >= dataInicio && hoje <= dataFinal;
        });
    } else if (filtroKpiCards === 'em-andamento') {
        filteredCourses = filteredCourses.filter((course) => {
            const porcentagem = parseInt(course.porcentagem_concluida, 10);
            return porcentagem > 0 && porcentagem < 100;
        });
    }

    const displayedCourses = filteredCourses.filter(course => {
        if (selectedTopic && course.idTopico !== selectedTopic) return false;
        if (selectedTipo && course.tipo !== selectedTipo) return false;
        return true;
    });

    // Calcular estatísticas dos cursos
    const stats = useMemo(() => {
        const hoje = new Date();
        
        if (nivel === 'Administrador' || nivel === 'RH') {
            // Indicadores para Admin/RH
            const total = dataCursos.length;
            const ativos = dataCursos.filter(course => {
                const dataInicio = new Date(course.dataInicio);
                const dataFinal = new Date(course.dataFinal);
                return hoje >= dataInicio && hoje <= dataFinal;
            }).length;
            const online = dataCursos.filter(course => course.tipo === 'online').length;
            const hibrido = dataCursos.filter(course => course.tipo === 'misto').length;
            
            return { total, ativos, online, hibrido };
        } else {
            // Indicadores para Aluno/Gestor
            const total = dataCursos.length;
            const finalizados = dataCursos.filter(course => parseInt(course.porcentagem_concluida) === 100).length;
            const emAndamento = dataCursos.filter(course => {
                const porcentagem = parseInt(course.porcentagem_concluida);
                return porcentagem > 0 && porcentagem < 100;
            }).length;
            const disponiveis = dataCursos.filter(course => {
                const dataInicio = new Date(course.dataInicio);
                const dataFinal = new Date(course.dataFinal);
                return hoje >= dataInicio && hoje <= dataFinal;
            }).length;
            
            return { total, finalizados, emAndamento, disponiveis };
        }
    }, [dataCursos, nivel]);

    // listar usuarios
    const [dataGestor, setDataGestor] = useState([]);
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await Api.get(`api/listar-usuarios/nivel/Gestor/todos`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setDataGestor(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        nivel === "Administrador" && fetchData();
    }, [token, nivel]);

    const {
        register: register_curso,
        handleSubmit: handleSubmit_curso,
        control: control_curso,
        // reset: reset_curso,
        setValue: setValue_curso,
        formState: { errors: errors_curso },
    } = useForm();

    async function onSubmitCertificado(e) {
        e.preventDefault();

        const data = {
            id: e.target.id.value,
            certificado: e.target.certificado.files,
            certificado_frente: e.target.certificado_frente.files
        }

        const formData = new FormData();

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }

        });

        try {
            const response = await Api.post("/api/editar-certificado", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' })
            setUploadCursoProgress(0)
            setShowModalCertificado(false)
            setCursoEditarCertificado(false)
            setCursoEditarCertificadoFrente(false)
            setShowButtonCertificado(false)
            setShowButtonCertificadoFrente(false)
            setPreviewUrlCertificado(null)
            setPreviewUrlCertificadoFrente(null)

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message, type: 'toast-error' })
            console.error("Erro ao editar curso:", error.response.data.message);
        }

        setShowToast(true);

    };

    const onSubmitEditarCurso = async (data) => {
        setIsLoadingEditarCurso(true);
        const formData = new FormData();

        Object.keys(data).forEach(key => {
            const value = data[key];
            if (typeof value === 'object' && value !== null && !(value instanceof FileList)) {
                formData.append(key, JSON.stringify(value));
            } else if (value instanceof FileList) {
                Array.from(value).forEach(file => {
                    formData.append(key, file);
                });
            } else {
                formData.append(key, value);
            }
        });

        try {
            const response = await Api.post("/api/editar-curso", formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    setUploadCursoProgress(percentCompleted + "%")
                    if (percentCompleted === 100) {
                        setTimeout(() => {
                            setUploadCursoProgress('Aguarde... finalizando...')
                        }, 1000);
                    }
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' })
            setUploadCursoProgress(0)
            setShowModalEditarCurso(false)
            
            // Recarregar a lista de cursos após edição bem-sucedida
            await recarregarCursos();

        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message, type: 'toast-error' })
            console.error("Erro ao editar curso:", error.response.data.message);
        } finally {
            setIsLoadingEditarCurso(false);
        }

        setShowToast(true);
    };

    const deletarCurso = async (id) => {
        setIsLoadingDeletarCurso(true);
        try {
            const response = await Api.delete(`/api/deletar-curso/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            // Remova o curso deletado do estado dataCursos para atualizar a UI
            const newDataCursos = dataCursos.filter(curso => curso.id !== id);
            setDataCursos(newDataCursos);
            setShowModalDeletarCurso(false);
        } catch (error) {
            console.error("Erro ao deletar curso:", error.response?.data?.message);
            const errorMessage = error.response?.data?.message || 'Erro ao deletar curso. Tente novamente mais tarde.';
            // Se a mensagem for longa (mais de 80 caracteres), usar toast grande
            const isLarge = errorMessage.length > 80;
            setToast({ header: 'Ops!', body: errorMessage, type: 'toast-error', isLarge });
            setShowModalDeletarCurso(false);

        } finally {
            setIsLoadingDeletarCurso(false);
            setShowToast(true);
        }
    }

    const abrirModalDeletarCertificado = (idCurso, tipo) => {
        setCertificadoParaDeletar({ idCurso, tipo });
        setShowModalCertificado(false); // Esconde o modal de editar
        setShowModalDeletarCertificado(true);
    }

    const confirmarDeletarCertificado = async () => {
        const { idCurso, tipo } = certificadoParaDeletar;

        try {
            const response = await Api.delete(`/api/deletar-certificado/${idCurso}/${tipo}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            setShowToast(true);
            setShowModalDeletarCertificado(false);
            // Mantém o modal de editar fechado após deletar

            // Atualizar o estado local
            if (tipo === 'verso') {
                setCertificadoEdit(null);
                setCursoInfo(prev => ({ ...prev, certificado: null }));
            } else {
                setCertificadoFrenteEdit(null);
                setCursoInfo(prev => ({ ...prev, certificado_frente: null }));
            }

            // Recarregar a lista de cursos
            const responseCursos = await Api.get(`api/listar-cursos`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setDataCursos(responseCursos.data);
        } catch (error) {
            console.error("Erro ao deletar certificado:", error);
            setToast({ 
                header: 'Ops!', 
                body: error.response?.data?.message || 'Erro ao deletar certificado',
                type: 'toast-error'
            });
            setShowToast(true);
            setShowModalDeletarCertificado(false);
            setShowModalCertificado(true); // Reabre o modal de editar se houver erro
        }
    }

    const optionsOrdenacao = [
        { value: "1", label: "Ordem alfabética" },
        { value: "2", label: "Recentes" },
        { value: "3", label: "Finalizados" },
        { value: "4", label: "Em andamento" }
    ];

    //Remover opção finalizados e Em andamento caso o nivel seja Administrador
    if (nivel === 'Administrador' || nivel === 'RH') {
        optionsOrdenacao.splice(2, 2);
    }

    const optionsTipo = [
        { value: 'online', label: 'Online' },
        { value: 'misto', label: 'Híbrido' }
    ];

    const handleKpiCardTotal = () => {
        setFiltroKpiCards(null);
        setSelectedTipo(null);
        setOrder('');
    };

    const handleKpiCardPeriodoToggle = () => {
        let abrindoPeriodo = false;
        setFiltroKpiCards((prev) => {
            const next = prev === 'periodo' ? null : 'periodo';
            abrindoPeriodo = next === 'periodo';
            return next;
        });
        if (abrindoPeriodo) {
            setOrder((o) => (o === '3' || o === '4' ? '' : o));
        }
    };

    const handleKpiCardTipoToggle = (tipo) => {
        setFiltroKpiCards(null);
        setSelectedTipo((prev) => (prev === tipo ? null : tipo));
    };

    const handleKpiFinalizadosToggle = () => {
        setFiltroKpiCards(null);
        setOrder((prev) => (prev === '3' ? '' : '3'));
    };

    const handleKpiEmAndamentoToggle = () => {
        let abrindoEmAndamento = false;
        setFiltroKpiCards((prev) => {
            const next = prev === 'em-andamento' ? null : 'em-andamento';
            abrindoEmAndamento = next === 'em-andamento';
            return next;
        });
        if (abrindoEmAndamento) setOrder('');
    };

    const kpiCardBaseClass = 'card border-0 shadow-sm h-100 bg-white position-relative user-select-none';


    // Detectar scroll e atualizar indicadores visuais do modal Editar Curso
    useEffect(() => {
        const checkScroll = () => {
            if (modalEditarCursoBodyRef.current) {
                const { scrollTop, scrollHeight, clientHeight } = modalEditarCursoBodyRef.current;
                setShowScrollTop(scrollTop > 10);
                setShowScrollBottom(scrollTop + clientHeight < scrollHeight - 10);
            }
        };

        const modalBodyElement = modalEditarCursoBodyRef.current;

        if (showModalEditarCurso && modalBodyElement) {
            checkScroll();
            modalBodyElement.addEventListener('scroll', checkScroll);
            const timeoutId = setTimeout(checkScroll, 100);

            return () => {
                modalBodyElement.removeEventListener('scroll', checkScroll);
                clearTimeout(timeoutId);
            };
        } else {
            // Resetar indicadores quando modal fecha
            setShowScrollTop(false);
            setShowScrollBottom(false);
        }
    }, [showModalEditarCurso]);

    return (
        <>
            <Toast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={6000}
                autohide
                className={`position-fixed top-0 end-0 m-3 toast-icon ${toast.type || 'toast-error'} ${toast.isLarge ? 'toast-large' : ''}`}
                style={{ zIndex: 1060 }}
            >
                <Toast.Header>
                    <strong className="me-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <div className="fade-in w-100 mt-3" style={{ marginBottom: '100px' }}>
                {/* Header Moderno com Indicadores */}
                <div className="rounded-3 mb-4">
                    <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                            <div>
                        <h1 className="text-primary fs-2 fw-bold mb-2">Meus Cursos</h1>
                        <p className="text-muted mb-0">
                            {nivel === 'Administrador' || nivel === 'RH' 
                                ? 'Gerencie e acompanhe todos os cursos cadastrados no sistema'
                                : 'Acesse, gerencie e acompanhe o progresso dos seus cursos disponíveis'
                            }
                        </p>
                            </div>
                            {(nivel === 'Administrador' || nivel === 'RH') && (
                                <div className="d-flex gap-2">
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={() => {
                                            topicosManager.openAddTopicoModal();
                                        }}
                                    >
                                        <i className="bi bi-plus-circle me-2"></i>
                                        Criar Tópico
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => {
                                            cursosManager.openAddCursoModal();
                                        }}
                                    >
                                        <i className="bi bi-plus-circle me-2"></i>
                                        Criar Curso
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row g-3">
                        <div className="col-md-3">
                            <div
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        handleKpiCardTotal();
                                    }
                                }}
                                className={`${kpiCardBaseClass} ${!filtroKpiCards && !selectedTipo && !order ? 'border border-2 border-primary' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={handleKpiCardTotal}
                            >
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div>
                                            <div className="fs-1 fw-bold" style={{ color: '#0d6efd' }}>{stats.total}</div>
                                            <div className="text-muted small mt-1">Total de Cursos</div>
                                        </div>
                                        <i className="bi bi-book" style={{ color: '#0d6efd', fontSize: '1.5rem' }}></i>
                                    </div>
                                    <div className="progress mt-3" style={{ height: '4px' }}>
                                        <div 
                                            className="progress-bar" 
                                            role="progressbar" 
                                            style={{ width: '100%', backgroundColor: '#0d6efd' }}
                                            aria-valuenow={stats.total} 
                                            aria-valuemin="0" 
                                            aria-valuemax={stats.total}
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {nivel === 'Administrador' || nivel === 'RH' ? (
                            <>
                                <div className="col-md-3">
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleKpiCardPeriodoToggle();
                                            }
                                        }}
                                        className={`${kpiCardBaseClass} ${filtroKpiCards === 'periodo' ? 'border border-2 border-primary' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={handleKpiCardPeriodoToggle}
                                    >
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <div className="fs-1 fw-bold" style={{ color: '#198754' }}>{stats.ativos}</div>
                                                    <div className="text-muted small mt-1">Cursos Ativos</div>
                                                </div>
                                                <i className="bi bi-play-circle" style={{ color: '#198754', fontSize: '1.5rem' }}></i>
                                            </div>
                                            <div className="progress mt-3" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar" 
                                                    role="progressbar" 
                                                    style={{ width: `${stats.total > 0 ? (stats.ativos / stats.total * 100) : 0}%`, backgroundColor: '#198754' }}
                                                    aria-valuenow={stats.ativos} 
                                                    aria-valuemin="0" 
                                                    aria-valuemax={stats.total}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleKpiCardTipoToggle('online');
                                            }
                                        }}
                                        className={`${kpiCardBaseClass} ${selectedTipo === 'online' ? 'border border-2 border-primary' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleKpiCardTipoToggle('online')}
                                    >
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <div className="fs-1 fw-bold" style={{ color: '#0d6efd' }}>{stats.online}</div>
                                                    <div className="text-muted small mt-1">Online</div>
                                                </div>
                                                <i className="bi bi-laptop" style={{ color: '#0d6efd', fontSize: '1.5rem' }}></i>
                                            </div>
                                            <div className="progress mt-3" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar" 
                                                    role="progressbar" 
                                                    style={{ width: `${stats.total > 0 ? (stats.online / stats.total * 100) : 0}%`, backgroundColor: '#0d6efd' }}
                                                    aria-valuenow={stats.online} 
                                                    aria-valuemin="0" 
                                                    aria-valuemax={stats.total}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleKpiCardTipoToggle('misto');
                                            }
                                        }}
                                        className={`${kpiCardBaseClass} ${selectedTipo === 'misto' ? 'border border-2 border-primary' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleKpiCardTipoToggle('misto')}
                                    >
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <div className="fs-1 fw-bold" style={{ color: '#20c997' }}>{stats.hibrido}</div>
                                                    <div className="text-muted small mt-1">Híbrido</div>
                                                </div>
                                                <i className="bi bi-people" style={{ color: '#20c997', fontSize: '1.5rem' }}></i>
                                            </div>
                                            <div className="progress mt-3" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar" 
                                                    role="progressbar" 
                                                    style={{ width: `${stats.total > 0 ? (stats.hibrido / stats.total * 100) : 0}%`, backgroundColor: '#20c997' }}
                                                    aria-valuenow={stats.hibrido} 
                                                    aria-valuemin="0" 
                                                    aria-valuemax={stats.total}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="col-md-3">
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleKpiFinalizadosToggle();
                                            }
                                        }}
                                        className={`${kpiCardBaseClass} ${order === '3' ? 'border border-2 border-primary' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={handleKpiFinalizadosToggle}
                                    >
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <div className="fs-1 fw-bold" style={{ color: '#198754' }}>{stats.finalizados}</div>
                                                    <div className="text-muted small mt-1">Finalizados</div>
                                                </div>
                                                <i className="bi bi-check-circle" style={{ color: '#198754', fontSize: '1.5rem' }}></i>
                                            </div>
                                            <div className="progress mt-3" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar" 
                                                    role="progressbar" 
                                                    style={{ width: `${stats.total > 0 ? (stats.finalizados / stats.total * 100) : 0}%`, backgroundColor: '#198754' }}
                                                    aria-valuenow={stats.finalizados} 
                                                    aria-valuemin="0" 
                                                    aria-valuemax={stats.total}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleKpiEmAndamentoToggle();
                                            }
                                        }}
                                        className={`${kpiCardBaseClass} ${filtroKpiCards === 'em-andamento' ? 'border border-2 border-primary' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={handleKpiEmAndamentoToggle}
                                    >
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <div className="fs-1 fw-bold" style={{ color: '#fd7e14' }}>{stats.emAndamento}</div>
                                                    <div className="text-muted small mt-1">Em Andamento</div>
                                                </div>
                                                <i className="bi bi-clock-history" style={{ color: '#fd7e14', fontSize: '1.5rem' }}></i>
                                            </div>
                                            <div className="progress mt-3" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar" 
                                                    role="progressbar" 
                                                    style={{ width: `${stats.total > 0 ? (stats.emAndamento / stats.total * 100) : 0}%`, backgroundColor: '#fd7e14' }}
                                                    aria-valuenow={stats.emAndamento} 
                                                    aria-valuemin="0" 
                                                    aria-valuemax={stats.total}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleKpiCardPeriodoToggle();
                                            }
                                        }}
                                        className={`${kpiCardBaseClass} ${filtroKpiCards === 'periodo' ? 'border border-2 border-primary' : ''}`}
                                        style={{ cursor: 'pointer' }}
                                        onClick={handleKpiCardPeriodoToggle}
                                    >
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <div>
                                                    <div className="fs-1 fw-bold" style={{ color: '#20c997' }}>{stats.disponiveis}</div>
                                                    <div className="text-muted small mt-1">Disponíveis</div>
                                                </div>
                                                <i className="bi bi-calendar-check" style={{ color: '#20c997', fontSize: '1.5rem' }}></i>
                                            </div>
                                            <div className="progress mt-3" style={{ height: '4px' }}>
                                                <div 
                                                    className="progress-bar" 
                                                    role="progressbar" 
                                                    style={{ width: `${stats.total > 0 ? (stats.disponiveis / stats.total * 100) : 0}%`, backgroundColor: '#20c997' }}
                                                    aria-valuenow={stats.disponiveis} 
                                                    aria-valuemin="0" 
                                                    aria-valuemax={stats.total}
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                {/* Barra de Filtros Compacta */}
                <div className="card border-0 shadow-sm mb-3">
                    <div className="card-body p-3">
                        <div className="row g-2 align-items-end">
                            <div className="col-md-5">
                                <label className="form-label text-primary fw-medium small mb-1">Buscar</label>
                                <div className="inner-addon right-addon">
                                    <i className="d-flex bi bi-search" />
                                    <input
                                        type="search"
                                        value={searchTerm || ""}
                                        onChange={e => setSearchTerm(e.target.value)}
                                        placeholder="Pesquise o curso desejado..."
                                        className="form-control py-2"
                                    />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label text-primary fw-medium small mb-1">Tema</label>
                                <Select
                                    options={dataTopicos.map((value) => ({
                                        value: value.id,
                                        label: value.nome,
                                    }))}
                                    styles={customStyles}
                                    placeholder="Selecione o tema"
                                    value={selectedTopic ? { value: selectedTopic, label: dataTopicos.find(t => t.id === selectedTopic)?.nome } : null}
                                    onChange={(option) => setSelectedTopic(option ? option.value : null)}
                                    isClearable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                />
                            </div>
                            <div className="col-md-3">
                                <button
                                    className="btn btn-outline-primary w-100 py-2"
                                    onClick={() => setShowDrawerFiltros(true)}
                                >
                                    <i className="bi bi-funnel me-1"></i>
                                    Mais filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Chips de Filtros Ativos */}
                {(selectedTopic || order || selectedTipo || filtroKpiCards) && (
                    <div className="mb-3 d-flex flex-wrap gap-2 align-items-center">
                        {filtroKpiCards === 'periodo' && (
                            <Badge bg="success" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
                                {nivel === 'Administrador' || nivel === 'RH' ? 'Cursos no período' : 'Disponíveis'}
                                <i
                                    className="bi bi-x cursor-pointer"
                                    onClick={() => setFiltroKpiCards(null)}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                            </Badge>
                        )}
                        {filtroKpiCards === 'em-andamento' && (
                            <Badge bg="warning" text="dark" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
                                Em andamento (1%–99%)
                                <i
                                    className="bi bi-x cursor-pointer"
                                    onClick={() => setFiltroKpiCards(null)}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                            </Badge>
                        )}
                        {selectedTopic && (
                            <Badge bg="primary" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
                                Tema: {dataTopicos.find(t => t.id === selectedTopic)?.nome}
                                <i 
                                    className="bi bi-x cursor-pointer" 
                                    onClick={() => setSelectedTopic(null)}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                            </Badge>
                        )}
                        {selectedTipo && (
                            <Badge bg="info" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
                                Tipo: {optionsTipo.find(t => t.value === selectedTipo)?.label}
                                <i 
                                    className="bi bi-x cursor-pointer" 
                                    onClick={() => setSelectedTipo(null)}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                            </Badge>
                        )}
                        {order && (
                            <Badge bg="secondary" className="d-flex align-items-center gap-1 px-3 py-2" style={{ fontSize: '0.875rem' }}>
                                Ordenação: {optionsOrdenacao.find(o => o.value === order)?.label}
                                <i 
                                    className="bi bi-x cursor-pointer" 
                                    onClick={() => setOrder('')}
                                    style={{ cursor: 'pointer' }}
                                ></i>
                            </Badge>
                        )}
                    </div>
                )}

                {/* Grid de Cursos */}
                <section className="mb-6 mb-md-0" style={{ 
                    width: '100%', 
                    flexGrow: 1, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    overflow: 'hidden' 
                }}>
                    <div style={{ 
                        display: 'grid',
                        gridTemplateColumns: gridColumns,
                        gridAutoRows: 'min-content',
                        gap: '1rem',
                        marginTop: '0',
                        flexGrow: 1,
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        padding: '0',
                        width: '100%',
                        alignContent: 'start',
                        alignItems: 'stretch',
                        ...containerTransitionStyle
                    }}>
                        {loading ? (
                            <CourseSkeletons count={8} showProgressBar={nivel === 'Aluno'} />
                        ) : (
                            displayedCourses.map((value) => (
                                <GridViewItem 
                                        key={value.id} 
                                        value={value} 
                                        nivel={nivel}
                                        certificadosStatus={certificadosStatus}
                                        imageOverlayStyle={imageOverlayStyle}
                                        overlayContentStyle={overlayContentStyle}
                                        handleImageError={handleImageError}
                                        formatDate={formatDate}
                                        dataGestor={dataGestor}
                                        dataTopicos={dataTopicos}
                                        setShowModalEditarCurso={setShowModalEditarCurso}
                                        setValue_curso={setValue_curso}
                                        setCursoEditarFile={setCursoEditarFile}
                                        setThumbEdit={setThumbEdit}
                                        setUploadCursoProgress={setUploadCursoProgress}
                                        setPreviewUrl={setPreviewUrl}
                                        setShowModalDeletarCurso={setShowModalDeletarCurso}
                                        setCursoInfo={setCursoInfo}
                                        setShowModalCertificado={setShowModalCertificado}
                                        setCertificadoEdit={setCertificadoEdit}
                                        setCertificadoFrenteEdit={setCertificadoFrenteEdit}
                                        setCursoEditarCertificado={setCursoEditarCertificado}
                                        setCursoEditarCertificadoFrente={setCursoEditarCertificadoFrente}
                                        setPreviewUrlCertificado={setPreviewUrlCertificado}
                                        setPreviewUrlCertificadoFrente={setPreviewUrlCertificadoFrente}
                                        setCertificadoImageError={setCertificadoImageError}
                                        setCertificadoFrenteImageError={setCertificadoFrenteImageError}
                                    />
                            ))
                        )}
                    </div>
                </section>
            </div>

            <Modal size="lg" show={showModalEditarCurso} onHide={() => setShowModalEditarCurso(false)} backdrop="static" className="modal-editar-curso">
                <form onSubmit={handleSubmit_curso(onSubmitEditarCurso)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-5 text-primary">Editar Curso</span>
                    </Modal.Header>
                    <Modal.Body 
                        ref={modalEditarCursoBodyRef}
                        className="bg-gray-100 modal-editar-curso-body"
                    >
                        {showScrollTop && (
                            <div className="scroll-indicator scroll-indicator-top">
                                <i className="bi bi-chevron-up"></i>
                            </div>
                        )}
                        <input type="hidden" {...register_curso('id', { required: true })} />
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="body">
                                        <div className="d-flex mb-5">
                                            <div className="d-flex flex-column w-100">
                                                <div className="row">

                                                    <div className="col-12 col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Nome</label>
                                                            <input type="text" {...register_curso('nome', { required: true })} placeholder="Nome do curso" className="form-control border-new-light" />
                                                            {errors_curso.nome && <span className='text-primary fs-7'>Nome do curso é obrigatório.</span>}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Descrição</label>
                                                            <TextareaAutosize minRows={1.5} {...register_curso('descricao')} placeholder="Breve descrição do curso" className="form-control border-new-light"></TextareaAutosize>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Tema</label>
                                                            <Controller
                                                                name="idTopico"
                                                                control={control_curso}
                                                                defaultValue={[]}
                                                                rules={{ required: true }}
                                                                render={({ field }) => (
                                                                    <Select
                                                                        {...field}
                                                                        options={dataTopicos.map((value) => {
                                                                            return {
                                                                                value: value.id,
                                                                                label: `${value.nome}`,
                                                                            };
                                                                        })}
                                                                        value={field.value}
                                                                        styles={customStyles}
                                                                        rules={{ required: true }}
                                                                        onChange={value => {
                                                                            field.onChange(value)
                                                                        }}
                                                                        placeholder="Selecione o tema"
                                                                        noOptionsMessage={() => "Nenhum tema encontrado."}
                                                                        menuPortalTarget={document.body}
                                                                        menuPosition="fixed"
                                                                    />
                                                                )}
                                                            />
                                                            {errors_curso.topico && <span className='text-primary fs-7'>Selecione um tema.</span>}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Thumbnail</label>
                                                            <label htmlFor="thumbnail" className={`form-control label-input ${cursoEditarFile ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center`}><i className="bi bi-card-image me-2"></i> Trocar Imagem</label>
                                                            <Controller
                                                                control={control_curso}
                                                                name="thumbnail"
                                                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                                                    <input
                                                                        id='thumbnail'
                                                                        type="file"
                                                                        onBlur={onBlur}
                                                                        ref={ref}
                                                                        onChange={(e) => {
                                                                            const files = e.target.files;
                                                                            handleThumbnailChange(e);
                                                                            onChange(files);
                                                                            if (files && files.length > 0) {
                                                                                setCursoEditarFile(true);
                                                                            } else {
                                                                                setCursoEditarFile(false);
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            {errors_curso.thumbnail && <span className='text-primary fs-7'>Imagem do curso é obrigatório.</span>}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-8">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Prazo de Validade <span className="text-dark">(em meses)</span></label>
                                                            <input
                                                                type="number"
                                                                {...register_curso("prazo_validade", { required: true })}
                                                                placeholder="Ex: 12"
                                                                className="form-control border-new-light"
                                                            />
                                                            {errors_curso.prazo_validade && <span className='text-primary fs-7'>Prazo de Validade é obrigatório.</span>}
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            {previewUrl ?
                                                                <img src={previewUrl} className='card-img card-img-edit rounded-3' alt="Thumbnail" />
                                                                :
                                                                <img src={`${process.env.REACT_APP_IMG_URL}/${thumbEdit}`} className='card-img card-img-edit rounded-3' alt="Thumbnail" />
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Resumo</label>
                                                            <TextareaAutosize {...register_curso('resumo')} placeholder="Informações gerais sobre o curso" className="form-control border-new-light"></TextareaAutosize>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Objetivo</label>
                                                            <TextareaAutosize {...register_curso('objetivo')} placeholder="Objetivos do curso" className="form-control border-new-light"></TextareaAutosize>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Conteúdo Programático</label>
                                                            <TextareaAutosize {...register_curso('conteudo_programatico')} placeholder="Conteúdo programático do curso" className="form-control border-new-light"></TextareaAutosize>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-4">
                                                        <div className="mb-3">
                                                            <label className="form-label text-primary fw-medium">Disponibilidade do curso</label>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-8">
                                                        <div className="mb-3">
                                                            <div className="d-flex justify-content-between">
                                                                <div className='w-50 pe-2'>
                                                                    <label className="form-label d-block text-dark">Data de Início</label>
                                                                    <input
                                                                        type="date"
                                                                        {...register_curso('dataInicio', { required: true })}
                                                                        className="form-control border-new-light"
                                                                    />
                                                                    {errors_curso.dataInicio && <span className='text-primary fs-7'>Data de início é obrigatória.</span>}
                                                                </div>
                                                                <div className='w-50'>
                                                                    <label className="form-label d-block text-dark">Data Final</label>
                                                                    <input
                                                                        type="date"
                                                                        {...register_curso('dataFinal', { required: true })}
                                                                        className="form-control border-new-light"
                                                                    />
                                                                    {errors_curso.dataFinal && <span className='text-primary fs-7'>Data final é obrigatória.</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 col-md-4">
                                                        <div className="mb-1">
                                                            <label className="form-label text-primary fw-medium">Tipo do curso</label>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-md-8">
                                                        <div className="mb-3">
                                                            <div className="d-flex justify-content-between">
                                                                <div className='w-50 pe-2'>
                                                                    <label className="form-label d-block text-dark">Híbrido</label>
                                                                    <input
                                                                        type="radio"
                                                                        {...register_curso('tipo', { required: true })}
                                                                        value="misto"
                                                                        className="form-check-input"
                                                                    />
                                                                </div>
                                                                <div className='w-50'>
                                                                    <label className="form-label d-block text-dark">Online</label>
                                                                    <input
                                                                        type="radio"
                                                                        {...register_curso('tipo', { required: true })}
                                                                        value="online"
                                                                        className="form-check-input"
                                                                    />
                                                                </div>
                                                            </div>
                                                            {errors_curso.tipo && <span className='text-primary fs-7'>Tipo do curso é obrigatório.</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="progress col-12">
                                                    <div className="progress-bar" role="progressbar" style={{ width: `${uploadCursoProgress}` }} aria-valuenow={uploadCursoProgress} aria-valuemin="0" aria-valuemax="100">{uploadCursoProgress}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {showScrollBottom && (
                            <div className="scroll-indicator scroll-indicator-bottom">
                                <i className="bi bi-chevron-down"></i>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="justify-content-end">
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn me-2" onClick={() => setShowModalEditarCurso(false)} disabled={isLoadingEditarCurso}>Cancelar</button>
                            <button type="submit" className="btn btn-primary" disabled={isLoadingEditarCurso}>
                                {isLoadingEditarCurso ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Salvando...
                                    </>
                                ) : (
                                    'Salvar'
                                )}
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size="xl" show={showModalCertificado} onHide={() => setShowModalCertificado(false)} backdrop="static">
                <form onSubmit={(e) => onSubmitCertificado(e)}>
                    <Modal.Header closeButton>
                        <span className="fw-semibold fs-5 text-primary">
                            <i className="bi bi-patch-check me-2"></i>
                            Editar Certificado
                        </span>
                    </Modal.Header>
                    <Modal.Body className="bg-gray-100 p-4">
                        <input type="hidden" id="id" value={cursoInfo.id} />
                        <div className="container-fluid">
                            <div className="row g-4">
                                {/* Conteúdo Programático */}
                                <div className="col-12 col-md-6">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0 fw-semibold">
                                                <i className="bi bi-file-earmark-image me-2"></i>
                                                Conteúdo Programático
                                            </h6>
                                            {certificadoEdit && (
                                                <button 
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => abrirModalDeletarCertificado(cursoInfo.id, 'verso')}
                                                    title="Deletar Conteúdo Programático"
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            )}
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label htmlFor="certificado" className={`form-control label-input ${cursoEditarCertificado ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center cursor-pointer`}>
                                                    <i className="bi bi-upload me-2"></i>
                                                    {cursoEditarCertificado ? 'Imagem Selecionada' : 'Fazer Upload'}
                                                </label>
                                                <input
                                                    id='certificado'
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const files = e.target.files;
                                                        handleCertificadoChange(e);
                                                        setCertificadoImageError(false);
                                                        if (files && files.length > 0) {
                                                            setCursoEditarCertificado(true);
                                                            setShowButtonCertificado(true);
                                                        } else {
                                                            setCursoEditarCertificado(false);
                                                            setShowButtonCertificado(false);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            
                                            <div className="position-relative border rounded-3 overflow-hidden" style={{ minHeight: '250px', background: '#f8f9fa' }}>
                                                {certificadoImageError || (!previewUrlCertificado && !certificadoEdit) ? (
                                                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted p-4">
                                                        <i className="bi bi-image" style={{ fontSize: '4rem', opacity: 0.5 }}></i>
                                                        <p className="mt-3 mb-0 fw-medium">Nenhuma imagem disponível</p>
                                                        <small className="text-muted">Faça upload de uma imagem para visualizar</small>
                                                    </div>
                                                ) : previewUrlCertificado ? (
                                                    <img 
                                                        src={previewUrlCertificado} 
                                                        className='w-100 h-100' 
                                                        style={{ objectFit: 'contain' }}
                                                        alt="Preview Certificado" 
                                                        onError={handleCertificadoImageError}
                                                    />
                                                ) : (
                                                    <img 
                                                        src={`${process.env.REACT_APP_IMG_URL}/${certificadoEdit}`} 
                                                        className='w-100 h-100' 
                                                        style={{ objectFit: 'contain' }}
                                                        alt="Certificado Atual" 
                                                        onError={handleCertificadoImageError}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Frente do Certificado */}
                                <div className="col-12 col-md-6">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0 fw-semibold">
                                                <i className="bi bi-file-earmark-image me-2"></i>
                                                Frente do Certificado
                                            </h6>
                                            {certificadoFrenteEdit && (
                                                <button 
                                                    type="button"
                                                    className="btn btn-sm btn-danger"
                                                    onClick={() => abrirModalDeletarCertificado(cursoInfo.id, 'frente')}
                                                    title="Deletar Frente do Certificado"
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            )}
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label htmlFor="certificado_frente" className={`form-control label-input ${cursoEditarCertificadoFrente ? 'border-success bg-success' : 'border-primary bg-primary'} text-white fw-medium text-center cursor-pointer`}>
                                                    <i className="bi bi-upload me-2"></i>
                                                    {cursoEditarCertificadoFrente ? 'Imagem Selecionada' : 'Fazer Upload'}
                                                </label>
                                                <input
                                                    id='certificado_frente'
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => {
                                                        const files = e.target.files;
                                                        handleCertificadoFrenteChange(e);
                                                        setCertificadoFrenteImageError(false);
                                                        if (files && files.length > 0) {
                                                            setCursoEditarCertificadoFrente(true);
                                                            setShowButtonCertificadoFrente(true);
                                                        } else {
                                                            setCursoEditarCertificadoFrente(false);
                                                            setShowButtonCertificadoFrente(false);
                                                        }
                                                    }}
                                                />
                                            </div>
                                            
                                            <div className="position-relative border rounded-3 overflow-hidden" style={{ minHeight: '250px', background: '#f8f9fa' }}>
                                                {certificadoFrenteImageError || (!previewUrlCertificadoFrente && !certificadoFrenteEdit) ? (
                                                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted p-4">
                                                        <i className="bi bi-image" style={{ fontSize: '4rem', opacity: 0.5 }}></i>
                                                        <p className="mt-3 mb-0 fw-medium">Nenhuma imagem disponível</p>
                                                        <small className="text-muted">Faça upload de uma imagem para visualizar</small>
                                                    </div>
                                                ) : previewUrlCertificadoFrente ? (
                                                    <img 
                                                        src={previewUrlCertificadoFrente} 
                                                        className='w-100 h-100' 
                                                        style={{ objectFit: 'contain' }}
                                                        alt="Preview Frente Certificado" 
                                                        onError={handleCertificadoFrenteImageError}
                                                    />
                                                ) : (
                                                    <img 
                                                        src={`${process.env.REACT_APP_IMG_URL}/${certificadoFrenteEdit}`} 
                                                        className='w-100 h-100' 
                                                        style={{ objectFit: 'contain' }}
                                                        alt="Frente Certificado Atual" 
                                                        onError={handleCertificadoFrenteImageError}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="justify-content-end">
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn me-2" onClick={() => setShowModalCertificado(false)}>
                                <i className="bi bi-x-circle me-2"></i>
                                Cancelar
                            </button>
                            <button type="submit" className={`btn btn-primary ${showButtonCertificado || showButtonCertificadoFrente ? '' : 'd-none'}`}>
                                <i className="bi bi-check-circle me-2"></i>
                                Salvar Alterações
                            </button>
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal size='lg' show={showModalDeletarCertificado} onHide={() => {
                setShowModalDeletarCertificado(false);
                setShowModalCertificado(true); // Reabre o modal de editar ao cancelar
            }}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-danger">
                        <i className="bi bi-exclamation-triangle me-2"></i>
                        Deletar Certificado
                    </span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p className="mb-3">
                                                        Tem certeza que deseja deletar o <b className="text-danger">
                                                            {certificadoParaDeletar.tipo === 'verso' ? 'Conteúdo Programático' : 'Frente do Certificado'}
                                                        </b>?
                                                    </p>
                                                    <p className="text-muted">
                                                        Esta ação não poderá ser desfeita. A imagem será removida permanentemente do sistema.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button type="button" className="btn me-2" onClick={() => {
                            setShowModalDeletarCertificado(false);
                            setShowModalCertificado(true); // Reabre o modal de editar ao cancelar
                        }}>
                            Cancelar
                        </button>
                        <button type="button" className="btn btn-danger" onClick={confirmarDeletarCertificado}>
                            <i className="bi bi-trash me-2"></i>
                            Confirmar Exclusão
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Modal size='lg' show={showModalDeletarCurso} onHide={() => setShowModalDeletarCurso(false)}>
                <Modal.Header closeButton>
                    <span className="fw-semibold fs-5 text-primary">Deletar curso</span>
                </Modal.Header>
                <Modal.Body className="bg-gray-100 p-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="body">
                                    <div className="d-flex">
                                        <div className="d-flex flex-column w-100">
                                            <div className="row">
                                                <div className="col-12">
                                                    <p>Tem certeza que deseja deletar o curso <b>{cursoInfo.nome}</b>?</p>
                                                    <p>Essa ação ira deletar o curso e todos seus módulos e aulas, e não poderá ser revertida.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <div className="d-flex justify-content-end">
                        <button 
                            type="button" 
                            className="btn me-2" 
                            onClick={() => setShowModalDeletarCurso(false)}
                            disabled={isLoadingDeletarCurso}
                        >
                            Cancelar
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-danger" 
                            onClick={() => deletarCurso(cursoInfo.id)}
                            disabled={isLoadingDeletarCurso}
                        >
                            {isLoadingDeletarCurso ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Deletando...
                                </>
                            ) : (
                                'Confirmar'
                            )}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* Drawer de Filtros Avançados */}
            <Offcanvas show={showDrawerFiltros} onHide={() => setShowDrawerFiltros(false)} placement="end" style={{ width: '400px' }}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="fw-semibold fs-5 text-primary">Filtros Avançados</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="bg-gray-100 d-flex flex-column">
                    <div className="mb-3">
                        <label className="form-label text-primary fw-medium mb-2">Tipo de Treinamento</label>
                        <Select
                            options={optionsTipo}
                            styles={customStyles}
                            placeholder="Selecione o tipo"
                            value={selectedTipo ? optionsTipo.find(t => t.value === selectedTipo) : null}
                            onChange={(option) => setSelectedTipo(option ? option.value : null)}
                            isClearable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label text-primary fw-medium mb-2">Ordenar por</label>
                        <Controller
                            name="ordenacao"
                            control={control_curso}
                            defaultValue={order || ''}
                            render={({ field }) => (
                                <Select
                                    {...field}
                                    options={optionsOrdenacao.map((option) => ({
                                        value: option.value,
                                        label: option.label,
                                    }))}
                                    value={optionsOrdenacao.find(option => option.value === field.value) || null}
                                    styles={customStyles}
                                    onChange={(selectedOption) => {
                                        const value = selectedOption ? selectedOption.value : '';
                                        field.onChange(value);
                                        setOrder(value);
                                    }}
                                    placeholder="Selecione a ordenação"
                                    isClearable
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    menuShouldScrollIntoView={false}
                                />
                            )}
                        />
                    </div>
                    <div className="mt-auto pt-3 border-top">
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                className="btn btn-outline-secondary flex-fill"
                                onClick={() => {
                                    setOrder('');
                                    setSelectedTopic(null);
                                    setSelectedTipo(null);
                                    setSearchTerm('');
                                    setFiltroKpiCards(null);
                                }}
                            >
                                Limpar filtros
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary flex-fill"
                                onClick={() => setShowDrawerFiltros(false)}
                            >
                                Aplicar filtros
                            </button>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            {/* Modais de Criação */}
            {cursosManager.renderModal(topicosManager)}
            {topicosManager.renderModal(() => cursosManager.openAddCursoModal())}
        </>
    )
}

export default MeusCursos;